import React, { useEffect, useState } from "react";
import ListOfBlogCard from "./ListOfBlogCard";
import { Link, useLocation, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import ComponentSEO from "../../components/SEO_Component/ComponentSEO";
import Card2Mock from "../../components/Card2mock";
import BreadcrumbNav from "../../components/BreadcrumbNav";

const ListOfBlogPage = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [isLoading, setLoading] = useState(true);

  const location = useLocation();

  function handleURL() {
    if (id == null) {
      return `${process.env.REACT_APP_API}blog`;
    }
    return `${process.env.REACT_APP_API}english/${id}`;
  }

  const fetchData = (url) => {
    fetch(`${url}?debug=true`)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
    fetchData(handleURL());
  }, []);

  return (
    <>
      {isLoading && (
        <div className="w-full flex items-center justify-center h-[80vh]">
          <CircularProgress />
        </div>
      )}
      {!isLoading && data.similar_blog && data.similar_blog.length > 0 ? (
        <div className="max-w-full">
          <BreadcrumbNav
            pathSegments={[
              {
                caption: "Home",
                href: "/english",
              },
              {
                caption:
                  (data.data && data.data.value && data.data.value.title) ||
                  "Blog",
                href: location.pathname,
              },
            ]}
          />
          <ComponentSEO
            title={data.seo.seo_title}
            desc={data.seo.seo_description}
          />
          <div className="flex flex-col bg-zinc-400 px-6 py-12 md:p-12 place-content-center items-center">
            <h1 className="text-2xl md:text-4xl text-white font-bold">
              {data.data && data.data.value && data.data.value.title
                ? `${data.data.value.title}`
                : "Personal Finance Blog"}
            </h1>
            <h3 className="text-base md:text-2xl md:mt-3 text-white text-center">
              {data.data && data.data.value && data.data.value.description ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.data.value.description,
                  }}
                ></div>
              ) : (
                "Investing | Credit Cards | Saving | Tax | Insurance"
              )}
            </h3>
          </div>
          {data.data && (
            <div className="text-2xl text-black font-bold ml-2 md:ml-32 my-20 flex mb-4">
              Recommended Blogs
            </div>
          )}
          <div className="px-4 md:px-48 grid grid-cols-1 divide-y">
            {data.similar_blog.map(
              (item) =>
                item && (
                  <div key={item.id}>
                    <ListOfBlogCard
                      title={item.title}
                      body={item.body}
                      url={item.url}
                      created={item.created}
                      featured_image={item.image}
                    />
                  </div>
                )
            )}
          </div>

          {data.data && data.data["calculators"] && (
            <div className="text-2xl text-black font-bold ml-2 md:ml-24 my-20 flex mb-4">
              {data.data.value.title} Calculators
            </div>
          )}
          <div className="md: grid md:grid-cols-3 px-10 py-6 gap-4 md:px-24 md:py-4 md:gap-3">
            {data.data &&
              data.data["calculators"] &&
              data.data["calculators"].map(
                (calc, index) =>
                  calc && (
                    <Link to={`/english/calculator/${calc.id}`}>
                      <div
                        key={index}
                        className="justify-center hover:cursor-pointer"
                      >
                        <Card2Mock img={calc.image} title={calc["title"]} />
                      </div>
                    </Link>
                  )
              )}
          </div>
        </div>
      ) : (
        <div className="h-[90vh] w-[90vw] flex items-center justify-center">
          <div className="font-montserrat font-semibold">
            {`No Blog Yet \n Visit Again`}
          </div>
        </div>
      )}
    </>
  );
};

export default ListOfBlogPage;
